type BuildLoginRedirectUrlParams = {
  useNewAuthFrontend: boolean;
  email: string;
  redirectPath: string;
};

// TODO DEV-21196: drop the useNewAuthFrontend arg and hardcode '/auth/login' once cutover complete
export const buildLoginRedirectUrl = ({
  useNewAuthFrontend,
  email,
  redirectPath,
}: BuildLoginRedirectUrlParams): string => {
  const base = useNewAuthFrontend ? '/auth/login' : '/login';
  const encodedRedirect = encodeURIComponent(redirectPath);

  if (email) {
    return `${base}?email=${encodeURIComponent(
      email
    )}&redirect=${encodedRedirect}`;
  }

  return `${base}?redirect=${encodedRedirect}`;
};
